// Shared per-route SEO builder: used by scripts/prerender.js (build-time HTML) and RouteSEO (browser Helmet tags).
export const SITE = process.env.REACT_APP_PRIMARY_SITE_URL.replace(/\/+$/, '');
export const BRAND = 'ASJK Laxmi Global';
const SUFFIX = ` | ${BRAND}`;
export const HI = '/hi';
export const STATIC_UPDATED = '2026-10-24';
const STORAGE_PREFIX = '/api/files/';
const ORG_ID = `${SITE}/#organization`;
export const ADDRESS = 'Nashik T Point, Chhatrapati Sambhajinagar, Maharashtra 431115, India';
const ROBOTS_INDEX = 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1';
export const OG_DEFAULT = { url: `${SITE}/og-default.jpg`, width: 1200, height: 630, alt: `${BRAND} — premium Indian spice powder exporter` };
export const NOINDEX_PATHS = ['/admin', '/login'];

export const STATIC_PAGES = {
  '/': {
    label: 'Home',
    en: ['Indian Spice Powder Exporter | ASJK Laxmi Global', 'Export-grade turmeric, red chilli, coriander, garlic, cumin and black pepper powders from Maharashtra, India. FSSAI certified. MOQ 1 MT.'],
    hi: ['भारतीय मसाला पाउडर निर्यातक | ASJK Laxmi Global', 'महाराष्ट्र से निर्यात-ग्रेड हल्दी, लाल मिर्च, धनिया, लहसुन, जीरा और काली मिर्च पाउडर। FSSAI प्रमाणित। न्यूनतम ऑर्डर 1 MT।'],
  },
  '/about': {
    label: 'About Us',
    en: ['About ASJK Laxmi Global | Spice Powder Exporter, India', 'FSSAI-certified, APEDA-registered spice powder exporter in Chhatrapati Sambhajinagar, Maharashtra, supplying importers in 15+ countries.'],
    hi: ['हमारे बारे में | मसाला पाउडर निर्यातक | ASJK Laxmi Global', 'छत्रपति संभाजीनगर, महाराष्ट्र का FSSAI प्रमाणित और APEDA पंजीकृत मसाला पाउडर निर्यातक, जो 15+ देशों के आयातकों को आपूर्ति करता है।'],
  },
  '/products': {
    label: 'Products',
    en: ['Export-Grade Indian Spice Powders | ASJK Laxmi Global', 'Turmeric, red chilli, coriander, garlic, cumin and black pepper powder for export. Full specifications, lab reports, MOQ from 1 MT, FOB/CIF pricing.'],
    hi: ['निर्यात-ग्रेड भारतीय मसाला पाउडर | ASJK Laxmi Global', 'निर्यात के लिए हल्दी, लाल मिर्च, धनिया, लहसुन, जीरा और काली मिर्च पाउडर। पूर्ण विनिर्देश, लैब रिपोर्ट, 1 MT से न्यूनतम ऑर्डर।'],
  },
  '/why-choose-us': {
    label: 'Why Choose Us',
    en: ['Why Importers Choose ASJK Laxmi Global', 'Farm-direct sourcing, lab-tested batches, FSSAI and APEDA compliance, flexible packaging and competitive FOB pricing for spice powder importers.'],
    hi: ['आयातक ASJK Laxmi Global को क्यों चुनते हैं', 'खेत से सीधी खरीद, लैब-परीक्षित बैच, FSSAI और APEDA अनुपालन, लचीली पैकेजिंग और प्रतिस्पर्धी FOB मूल्य।'],
  },
  '/export-markets': {
    label: 'Export Markets',
    en: ['Spice Powder Export Markets | ASJK Laxmi Global', 'We ship Indian spice powders to the UAE, UK, USA, Germany, Saudi Arabia, Mauritius and more, with full export documentation from Maharashtra.'],
    hi: ['मसाला पाउडर निर्यात बाजार | ASJK Laxmi Global', 'हम UAE, UK, USA, जर्मनी, सऊदी अरब, मॉरीशस और अन्य देशों में पूर्ण निर्यात दस्तावेज़ों के साथ भारतीय मसाला पाउडर भेजते हैं।'],
  },
  '/contact': {
    label: 'Contact',
    en: ['Request a Spice Powder Quote | ASJK Laxmi Global', 'Request a quote for bulk Indian spice powders. Email asjklaxmiglobal@gmail.com or call +91 92845 48218. Our export team replies within 24 hours.'],
    hi: ['मसाला पाउडर कोटेशन अनुरोध | ASJK Laxmi Global', 'थोक भारतीय मसाला पाउडर के लिए कोटेशन मांगें। ईमेल asjklaxmiglobal@gmail.com या कॉल +91 92845 48218। हम 24 घंटे में जवाब देते हैं।'],
  },
  '/blog': {
    label: 'Blog',
    en: ['Spice Export Blog & Import Guides | ASJK Laxmi Global', 'Guides for spice importers: quality parameters, certifications, grades and shipping for turmeric, chilli, cumin, garlic and pepper powders from India.'],
  },
  '/admin': { label: 'Admin', en: ['Admin Dashboard | ASJK Laxmi Global', 'Admin area.'] },
  '/login': { label: 'Login', en: ['Admin Login | ASJK Laxmi Global', 'Admin sign in.'] },
};

const PRODUCT_NAMES_HI = {
  turmeric: 'हल्दी पाउडर', 'red-chilli': 'लाल मिर्च पाउडर', coriander: 'धनिया पाउडर',
  garlic: 'लहसुन पाउडर', cumin: 'जीरा पाउडर', 'black-pepper': 'काली मिर्च पाउडर',
};

const NOSCRIPT_STATIC = {
  '/': '<p>ASJK Laxmi Global supplies export-grade Indian spice powders to importers, food manufacturers and distributors in 15+ countries. Every batch is ground from cleaned, farm-sourced spices, lab tested and packed in 25 kg bags or custom packaging.</p>',
  '/about': '<p>ASJK Laxmi Global is a spice powder export company based in Chhatrapati Sambhajinagar, Maharashtra. We hold FSSAI licence 10018022007595, IEC CNUPK2717H, GST registration and APEDA registration.</p>',
  '/products': '<p>All powders are FSSAI certified, lab tested and available from 1 MT (garlic powder from 2 MT) with FOB or CIF pricing.</p>',
  '/why-choose-us': '<p>Farm-direct sourcing, lab testing of every batch, flexible packaging, full export documentation and competitive FOB/CIF pricing.</p>',
  '/export-markets': '<p>We ship to the Middle East, Europe, Asia, Africa and the Americas in FCL or LCL from JNPT and Mundra ports, with phytosanitary, origin, fumigation and lab certificates.</p>',
  '/contact': `<p>Email: asjklaxmiglobal@gmail.com | Phone and WhatsApp: +91 92845 48218 | Address: ${ADDRESS}</p>`,
  '/blog': '<p>Guides for spice importers on quality parameters, certifications, grades and shipping.</p>',
};

export const escapeHtml = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const squash = (s) => String(s ?? '').replace(/\s+/g, ' ').trim();

export function clamp(text, limit = 160) {
  const clean = squash(text);
  if (clean.length <= limit) return clean;
  let out = '';
  for (const sentence of clean.split(/(?<=[.!?।])\s+/)) {
    const candidate = `${out} ${sentence}`.trim();
    if (candidate.length > limit) break;
    out = candidate;
  }
  if (out) return out;
  return `${clean.slice(0, limit - 1).replace(/\s+\S*$/, '').replace(/[,;:—-]+$/, '')}…`;
}

export function branded(title, limit = 65) {
  let clean = squash(title);
  if (clean.toLowerCase().includes(BRAND.toLowerCase())) return clean;
  if (clean.length > limit && clean.includes(' | ')) clean = clean.split(' | ')[0];
  return clean.length + SUFFIX.length <= limit ? `${clean}${SUFFIX}` : clean;
}

export function splitLang(rawPath) {
  const path = `/${String(rawPath || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '')}`;
  if (path === HI || path.startsWith(`${HI}/`)) return { lang: 'hi', path: path.slice(HI.length) || '/' };
  return { lang: 'en', path };
}

export const localPath = (path, lang) => (lang === 'hi' ? `${HI}${path === '/' ? '' : path}` : path);
export const pageUrl = (path, lang = 'en') => `${SITE}${localPath(path, lang)}`;

export function ogImage(src, alt) {
  if (src && src.startsWith(STORAGE_PREFIX)) {
    return { url: `${SITE}/api/og/${src.slice(STORAGE_PREFIX.length)}.jpg`, width: 1200, height: 630, alt };
  }
  if (src && src.startsWith('https://images.unsplash.com/')) {
    const url = new URL(src);
    ['w', 'h', 'fit', 'fm'].forEach((k, i) => url.searchParams.set(k, ['1200', '630', 'crop', 'jpg'][i]));
    return { url: url.toString(), width: 1200, height: 630, alt };
  }
  return OG_DEFAULT;
}

const breadcrumbs = (items) => ({
  '@context': 'https://schema.org', '@type': 'BreadcrumbList',
  itemListElement: items.map(([name, item], i) => ({ '@type': 'ListItem', position: i + 1, name, item })),
});

const alternates = (path) => [
  { hreflang: 'en', href: pageUrl(path, 'en') },
  { hreflang: 'hi', href: pageUrl(path, 'hi') },
  { hreflang: 'x-default', href: pageUrl(path, 'en') },
];

const decode = (s) => s.replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'");

// Text-only rendering of admin HTML for <noscript>; every value is re-escaped.
export function htmlToSafeBlocks(html) {
  const source = String(html || '').replace(/<(script|style)[\s\S]*?<\/\1>/gi, '');
  const blocks = [...source.matchAll(/<(h2|h3|h4|p|li)\b[^>]*>([\s\S]*?)<\/\1>/gi)]
    .map(([, tag, inner]) => [tag.toLowerCase() === 'h4' ? 'h3' : tag.toLowerCase(), squash(decode(inner.replace(/<[^>]+>/g, ' ')))])
    .filter(([, text]) => text);
  return blocks.map(([tag, text]) => (tag === 'li' ? `<ul><li>${escapeHtml(text)}</li></ul>` : `<${tag}>${escapeHtml(text)}</${tag}>`))
    .join('').replace(/<\/ul><ul>/g, '');
}

const listValue = (v) => (Array.isArray(v) ? v.join(', ') : String(v ?? ''));

function navHtml(ctx) {
  const links = [['/', 'Home'], ['/products', 'Spice Powders'], ['/about', 'About Us'], ['/why-choose-us', 'Why Choose Us'],
    ['/export-markets', 'Export Markets'], ['/blog', 'Blog'], ['/contact', 'Request a Quote'],
    ...ctx.products.map(p => [`/products/${p.id}`, p.name]),
    ...ctx.markets.map(m => [`/market/${m.slug}`, `Spice powder exports to ${m.country}`])];
  return `<ul>${links.map(([href, label]) => `<li><a href="${escapeHtml(href)}">${escapeHtml(label)}</a></li>`).join('')}</ul>`;
}

const noscript = (heading, body, ctx) => `<div><p><strong>${escapeHtml(heading)}</strong></p>${body}<p>${escapeHtml(`${BRAND} — ${ADDRESS} — asjklaxmiglobal@gmail.com — +91 92845 48218`)}</p>${navHtml(ctx)}</div>`;

function base(path, lang, title, description, extra = {}) {
  return {
    path: localPath(path, lang), lang, status: 200, title, description: clamp(description),
    canonical: pageUrl(path, lang), robots: ROBOTS_INDEX, ogType: 'website', ogImage: OG_DEFAULT,
    alternates: [], schemas: [], lastmod: STATIC_UPDATED, noscript: '', ...extra,
  };
}

const itemList = (products) => ({
  '@context': 'https://schema.org', '@type': 'ItemList', name: 'Indian Spice Powder Export Products', numberOfItems: products.length,
  itemListElement: products.map((p, i) => ({ '@type': 'ListItem', position: i + 1, url: pageUrl(`/products/${p.id}`), name: p.name })),
});

const latest = (docs, keys) => [STATIC_UPDATED, ...docs.flatMap(d => keys.map(k => d[k]).filter(Boolean).map(v => String(v).slice(0, 10)))].sort().pop();

function staticMeta(path, lang, ctx) {
  const page = STATIC_PAGES[path];
  const paired = Boolean(page.hi);
  const [title, description] = lang === 'hi' && paired ? page.hi : page.en;
  const meta = base(path, lang, title, description, { canonical: pageUrl(path, paired ? lang : 'en') });
  if (paired) meta.alternates = alternates(path);
  if (NOINDEX_PATHS.includes(path)) meta.robots = 'noindex, nofollow';
  if (path === '/' || path === '/products') meta.schemas.push(itemList(ctx.products));
  if (path !== '/' && !NOINDEX_PATHS.includes(path)) meta.schemas.push(breadcrumbs([['Home', pageUrl('/', lang)], [page.label, pageUrl(path, lang)]]));
  let body = NOSCRIPT_STATIC[path] || '';
  if (path === '/products') body += ctx.products.map(p => `<h2>${escapeHtml(p.name)}</h2><p>${escapeHtml(p.description)}</p>`).join('');
  if (path === '/blog') body += `<ul>${ctx.posts.map(b => `<li><a href="/blog/${escapeHtml(b.slug)}">${escapeHtml(b.title)}</a></li>`).join('')}</ul>`;
  meta.noscript = noscript(title.replace(SUFFIX, ''), body, ctx);
  const lastmods = { '/products': latest(ctx.products, ['updated_at', 'created_at']), '/blog': latest(ctx.posts, ['updated_at', 'created_at']), '/export-markets': latest(ctx.markets, ['updated_at']) };
  meta.lastmod = path === '/' ? Object.values(lastmods).sort().pop() : (lastmods[path] || STATIC_UPDATED);
  return meta;
}

function productMeta(p, lang, ctx) {
  const path = `/products/${p.id}`;
  const specs = p.specs || {};
  const moq = specs.moq || '1 MT';
  const firstSentence = String(p.description || '').trim().split(/(?<=\.)\s/)[0];
  let title;
  let description;
  if (lang === 'hi') {
    const hiName = PRODUCT_NAMES_HI[p.id] || p.name;
    title = branded(`${hiName} निर्यातक`);
    description = `${hiName} (${p.name}) निर्यात के लिए। FSSAI प्रमाणित, लैब-परीक्षित, न्यूनतम ऑर्डर ${moq}। FOB/CIF मूल्य के लिए संपर्क करें।`;
  } else {
    title = branded(`${p.name} Exporter from India`, 60);
    if (title.length > 60) title = branded(`${p.name} Exporter`, 60);
    description = `${firstSentence} MOQ ${moq}, FSSAI certified, lab tested.`;
  }
  const image = ogImage(p.image, p.name);
  const meta = base(path, lang, title, description, { ogType: 'product', ogImage: image, alternates: alternates(path) });
  meta.schemas = [
    {
      '@context': 'https://schema.org', '@type': 'Product', name: p.name, description: p.description || '', url: pageUrl(path), image: image.url,
      brand: { '@type': 'Brand', name: BRAND }, manufacturer: { '@id': ORG_ID }, category: 'Indian Spice Powders',
      offers: { '@type': 'Offer', availability: 'https://schema.org/InStock', priceCurrency: 'USD', seller: { '@id': ORG_ID } },
    },
    breadcrumbs([['Home', pageUrl('/', lang)], ['Products', pageUrl('/products', lang)], [p.name, pageUrl(path, lang)]]),
  ];
  const specItems = Object.entries(specs).filter(([, v]) => v && String(v).trim())
    .map(([k, v]) => `<li>${escapeHtml(k.replace(/_/g, ' '))}: ${escapeHtml(listValue(v))}</li>`).join('');
  meta.noscript = noscript(p.name, `<p>${escapeHtml(p.description)}</p><ul>${specItems}</ul>`, ctx);
  meta.lastmod = String(p.updated_at || p.created_at || STATIC_UPDATED).slice(0, 10);
  return meta;
}

function postMeta(b, lang, ctx) {
  const path = `/blog/${b.slug}`;
  const image = ogImage(b.cover_image, b.title);
  const published = b.created_at || STATIC_UPDATED;
  const modified = b.updated_at || published;
  const meta = base(path, lang, branded(b.title, 60), b.excerpt, { ogType: 'article', ogImage: image, canonical: pageUrl(path) });
  meta.article = { publishedTime: published, modifiedTime: modified, tags: b.tags || [] };
  meta.schemas = [
    {
      '@context': 'https://schema.org', '@type': 'BlogPosting', headline: String(b.title).slice(0, 110), description: b.excerpt || '',
      image: [image.url], datePublished: published, dateModified: modified,
      author: { '@type': 'Organization', name: BRAND, url: SITE }, publisher: { '@id': ORG_ID },
      mainEntityOfPage: { '@type': 'WebPage', '@id': pageUrl(path) }, keywords: (b.tags || []).join(', '),
    },
    breadcrumbs([['Home', pageUrl('/')], ['Blog', pageUrl('/blog')], [b.title, pageUrl(path)]]),
  ];
  meta.noscript = noscript(b.title, `<p>${escapeHtml(b.excerpt)}</p>${htmlToSafeBlocks(b.content)}`, ctx);
  meta.lastmod = String(modified).slice(0, 10);
  return meta;
}

function marketMeta(m, lang, ctx) {
  const path = `/market/${m.slug}`;
  const title = branded(m.meta_title || `Indian Spice Powder Exporter to ${m.country}`);
  const meta = base(path, lang, title, m.meta_description || m.intro, { canonical: pageUrl(path) });
  meta.schemas = [breadcrumbs([['Home', pageUrl('/')], ['Export Markets', pageUrl('/export-markets')], [m.country, pageUrl(path)]])];
  const ids = m.products || [];
  const listed = ctx.products.filter(p => ids.includes(p.id));
  const shown = listed.length ? listed : ctx.products.slice(0, 4);
  const productList = `<ul>${shown.map(p => `<li><a href="/products/${escapeHtml(p.id)}">${escapeHtml(p.name)}</a></li>`).join('')}</ul>`;
  meta.noscript = noscript(m.h1 || m.country, `<p>${escapeHtml(m.intro)}</p>${htmlToSafeBlocks(m.content)}${productList}`, ctx);
  meta.lastmod = String(m.updated_at || STATIC_UPDATED).slice(0, 10);
  return meta;
}

export function notFoundMeta(rawPath, ctx) {
  const { lang } = splitLang(rawPath);
  return {
    ...base('/', lang, `Page Not Found${SUFFIX}`, 'The page you are looking for does not exist.'),
    path: rawPath, status: 404, robots: 'noindex, follow', canonical: null,
    noscript: noscript('Page not found', '<p>Sorry, this page does not exist. Try one of the links below.</p>', ctx),
  };
}

function applyOverride(meta, override) {
  if (!override) return meta;
  return {
    ...meta,
    title: override.meta_title || meta.title,
    description: override.meta_description || meta.description,
    canonical: override.canonical_url || meta.canonical,
    robots: override.noindex ? 'noindex, follow' : meta.robots,
  };
}

export function normalizeContext(raw = {}) {
  return {
    products: raw.products || [],
    posts: (raw.posts || []).filter(b => b.published !== false),
    markets: (raw.markets || []).filter(m => m.published !== false),
    overrides: Object.fromEntries((raw.overrides || []).map(o => [o.path, o])),
  };
}

export function buildPageMeta(rawPath, ctx) {
  const { lang, path } = splitLang(rawPath);
  const tail = (prefix) => (path.startsWith(prefix) ? path.slice(prefix.length) : null);
  let meta = null;
  if (STATIC_PAGES[path]) meta = staticMeta(path, lang, ctx);
  else if (tail('/products/')) meta = (p => p && productMeta(p, lang, ctx))(ctx.products.find(p => p.id === tail('/products/')));
  else if (tail('/blog/')) meta = (b => b && postMeta(b, lang, ctx))(ctx.posts.find(b => b.slug === tail('/blog/')));
  else if (tail('/market/')) meta = (m => m && marketMeta(m, lang, ctx))(ctx.markets.find(m => m.slug === tail('/market/')));
  if (!meta) return notFoundMeta(rawPath, ctx);
  return applyOverride(meta, ctx.overrides[meta.path]);
}

export function allPaths(ctx) {
  const paths = [
    ...Object.keys(STATIC_PAGES),
    ...ctx.products.map(p => `/products/${p.id}`),
    ...ctx.posts.map(b => `/blog/${b.slug}`),
    ...ctx.markets.map(m => `/market/${m.slug}`),
  ];
  return [...paths, ...paths.filter(p => !NOINDEX_PATHS.includes(p)).map(p => localPath(p, 'hi'))];
}
